
import * as storyblokRuntime$bEMbHezpMW from '/builds/common/careers/careers-static/node_modules/@nuxt/image-edge/dist/runtime/providers/storyblok'
import * as ipxRuntime$0jeWAd5tTH from '/builds/common/careers/careers-static/node_modules/@nuxt/image-edge/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "a.storyblok.com",
    "assets.airbaltic.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$bEMbHezpMW, defaults: {"baseURL":"https://assets.airbaltic.com"} },
  ['ipx']: { provider: ipxRuntime$0jeWAd5tTH, defaults: undefined }
}
        